import { SgdfTable } from './Table.js';
window.customElements.define('sgdf-table', SgdfTable);
//# sourceMappingURL=sgdf-table.js.map